// import React, { useState, useEffect } from 'react';
// import jwt_decode from 'jwt-decode';
// import axios from "axios";
// import { GoogleLoginButton } from "react-social-login-buttons";

// const App = () => {
//   const [user, setUser] = useState({});

//   const handleCallbackResponse = (response) => {
//     console.log('Encoded JWT ID token: ' + response.credential);
//     var userObject = jwt_decode(response.credential);
//     console.log(userObject);
//     setUser(userObject);
//     document.getElementById('signInDiv').hidden = true;
//   }

//   const handleSignOut = (event) => {
//     setUser({});
//     document.getElementById('signInDiv').hidden = false;
//   }

//   const handleGoogleSignIn = async (response) => {
//     try {
//       const { email, phoneNumber, fullName, accessToken } = response;
//       var userObject = jwt_decode(accessToken);
//       setUser(userObject);
//       const apiResponse = await axios.post('http://3.108.63.210/users/login/', {
//         login_type: 'google',
//         mobile: phoneNumber,
//         email,
//         full_name: fullName
//       });
//       console.log(apiResponse.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     /* global google */
//     window.google.accounts.id.initialize({
//       client_id:
//         '427413220372-95clcfe33hhtriiu60qm7tgb7o34uf56.apps.googleusercontent.com',
//       callback: handleCallbackResponse,
//     });
//     window.google.accounts.id.renderButton(document.getElementById('signInDiv'), {
//       theme: 'outline',
//       size: 'large',
//       prompt_parent_id: 'googlePrompt'
//     });

//     google.accounts.id.prompt();
//   }, []);

//   return (
//     <div className="App">
//       <div id="signInDiv"></div>

//       {Object.keys(user).length !== 0 &&
//         <button onClick={handleSignOut}>Sign Out</button>
//       }
//       {Object.keys(user).length !== 0 &&
//         <div>
//           {/* <img src={user.picture} alt="Profile"></img> */}
//           <h3>{user.name}</h3>
//           <h3>{user.email}</h3>
//         </div>
//       }

//     </div>
//   );
// }

// export default App;

// --------------------working code--------------------------

import React, { useEffect, useState } from "react";
import { GoogleLogin } from "react-google-login";
import ReactGA from 'react-ga4';
import axios from "axios";
import { BASE_URL } from "../../api";
import { useUserAuth } from "../UserAuthContext/UserAuthContext";
import { gapi } from "gapi-script";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode"; // Import the jwt-decode library

const GoogleLoginButton = () => {
  const [authData, setAuthData] = useState({});
  const { handleLogin, handleLogout } = useUserAuth();
  const navigate = useNavigate();

  const handleGoogleLoginSuccess = async (response) => {
    ReactGA.event({
      category: 'Login',
      action: 'Button Click',
      label: 'Google Login',
    });
    
    navigate("/");

    try {
      const {
        profileObj: { email, name, imageUrl },
      } = response;

      const res = await axios.post(`${BASE_URL}users/login/`, {
        email,
        full_name: name,
        imageUrl,
        login_type: "google",
      });
      const token = res.data.data["token"];
      handleLogin(res.data.token);
      localStorage.setItem("token", token);
      // console.log(token);
      // console.log(res.data);
      setAuthData(res.data.data);
      handleLogin(res.data.token);

      // console.log(res.data);

      // Decode the token and get user data
      const decodedToken = jwt_decode(res.data.token);
      console.log(decodedToken);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleGoogleLoginFailure = (error) => {
    console.log(error);
  };

  const handleGoogleLogout = () => {
    gapi.auth2.getAuthInstance().signOut();
    handleLogout();
    setAuthData({});
  };

  const clientId =
    "427413220372-95clcfe33hhtriiu60qm7tgb7o34uf56.apps.googleusercontent.com"; // Replace with your client ID
  useEffect(() => {
    gapi.load("client:auth2", () => {
      gapi.auth2.init({ clientId: clientId });
    });
  }, []);

  return (
    <>
      {authData.token ? (
        <button onClick={handleGoogleLogout}>Logout</button>
      ) : (
        <GoogleLogin
          className="GoogleBtn-main"
          clientId={clientId}
          buttonText="Login with Google"
          onSuccess={handleGoogleLoginSuccess}
          onFailure={handleGoogleLoginFailure}
          cookiePolicy={"none"}
          responseType="code token"
        />
      )}

      <div className="Googlebutton">
        {Object.keys(authData).length !== 0 && (
          <div>
            <h2>{authData.full_name}</h2>
            <h2>{authData.email}</h2>
          </div>
        )}
      </div>
    </>
  );
};

export default GoogleLoginButton;
